/**
 * ArenaConfig — single visible toggle surface for the /arena URL.
 *
 * The Arena is the **multi-level** PvP testing surface (what /brawl was
 * originally intended to be): stacked tiers — ground floor, mid ledges per
 * side, and a central high-ground — so DJ can test PvP at every elevation and
 * range (ranged-down-onto-melee, climbing, falling, LOS over cover). /brawl is
 * the flat chaotic free-for-all; /arena is the deliberate structured one.
 *
 * Mirrors BrawlConfig's wiring: main.tsx reads it on /arena mount, and
 * ArenaMultiLevel.ts reads it to populate metadata.{pvp,bot} at module init.
 * Edit values here — no need to touch the map file.
 */

export const ARENA_CONFIG = {
  // First /arena navigation per tab wipes the Twitch cookie + helix_* storage.
  resetOnLoad: true,

  // What DJ spawns into.
  defaultClass: 'warrior' as const,

  /**
   * Opponent roster — includes Shaman movement replication tester bot.
   */
  botRoster: [
    { class: 'shaman', tier: 'movement-tester', name: 'Stormcaller', tileX: 45, tileY: 51 },
  ] as Array<{
    class: string; tier: 'aggressive' | 'passive' | 'movement-tester'; name: string; tileX: number; tileY: number;
  }>,

  // PvP knobs — flow into ArenaMultiLevel.metadata.overrides.pvp at module init.
  pvpEnabled: true,
  friendlyFire: 'all' as 'all' | 'players-only' | 'off',
  botBehavior: 'attack-all' as 'attack-all' | 'attack-non-owner' | 'ignore',
  respawnDelayMs: 2000,
  respawnInvulnerabilityMs: 1500,

  // HUD: live-lobby preset (clean viewport, nameplates/HP on, dev UI off).
  preset: 'live-lobby' as const,
  skipSplash: true,
  skipLogin: true,
} as const;
